var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"disabled":!_vm.react_id,"title":"Setup layout","icon":_vm.$icons.layout},on:{"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }